import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Button } from "@mui/material";
import PropTypes from "prop-types";
import { getObjectFromSearchParams } from "../../../helpers/methods";
import useFileService from "../../../services/fileService";
import LocalstorageService from "../../../services/localStorageService";
import { MAX_NUMBER_OF_INSTANCES_TO_EXPORT_TO_FILE } from "../../../helpers/constants";

const ExportToFileButton = (props) => {
    const { downloadFile } = useFileService();

    const exportToFile = () => {
        const preparedSearchParams =
            props.searchParams instanceof URLSearchParams
                ? getObjectFromSearchParams(props.searchParams)
                : props.searchParams;
        
        downloadFile(
            props.exportFileUrl,
            props.fileName,
            { headers: props.headers },
            {
                ...preparedSearchParams,
                ...props.exportToFileRequestContent,
                language: LocalstorageService.getLanguage(),
            },
            props.countRecords && props.countRecords > MAX_NUMBER_OF_INSTANCES_TO_EXPORT_TO_FILE
        );
    };

    return (
        <Button
            variant="contained"
            size="small"
            onClick={exportToFile}
            startIcon={<FileDownloadIcon />}
        >
            EXPORT
        </Button>
    );
};

ExportToFileButton.propTypes = {
    exportFileUrl: PropTypes.string,
    headers: PropTypes.array,
    searchParams: PropTypes.object,
    fileName: PropTypes.string,
    exportToFileRequestContent: PropTypes.object,
};

ExportToFileButton.defaultProps = {
    exportToFileRequestContent: {},
};

export default ExportToFileButton;
